"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DuplicateModelUtils", {
    enumerable: true,
    get: function() {
        return DuplicateModelUtils;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _ncError = require("~/helpers/ncError");
let DuplicateModelUtils = class DuplicateModelUtils {
    static get _() {
        return new DuplicateModelUtils();
    }
    async getTargetContext(context, _options) {
        return {
            context,
            isDifferent: false
        };
    }
    async verifyTargetContext(_sourceContext, _targetContext, _modelId, _options) {
        return true;
    }
    async getDuplicateModelTaskInfo({ context, baseId, modelId, body }) {
        var _body_title;
        const base = await _models.Base.get(context, baseId);
        if (!base) {
            _ncError.NcError.get(context).baseNotFound(baseId);
        }
        const model = await _models.Model.get(context, modelId);
        if (!model) {
            _ncError.NcError.get(context).tableNotFound(modelId);
        }
        const sourceSource = await _models.Source.get(context, model.source_id);
        const { context: targetContext, isDifferent: isTargetContextDifferent } = await this.getTargetContext(context, body.options);
        await this.verifyTargetContext(context, targetContext, modelId, body.options);
        if (isTargetContextDifferent) {
            const baseUser = await _models.BaseUser.get(targetContext, targetContext.base_id, context.user.id);
            if (![
                _nocodbsdk.ProjectRoles.OWNER,
                _nocodbsdk.ProjectRoles.CREATOR
            ].includes(baseUser.roles)) {
                _ncError.NcError.get(context).forbidden(`Only owner or creator can create table at specified base`);
            }
        }
        const targetBase = isTargetContextDifferent ? await _models.Base.get(targetContext, targetContext.base_id) : base;
        const targetSource = isTargetContextDifferent ? (await targetBase.getSources())[0] : sourceSource;
        // if data/schema is readonly, then restrict duplication
        if (targetSource.is_schema_readonly) {
            _ncError.NcError.get(context).sourceMetaReadOnly(targetSource.alias);
        }
        if (targetSource.is_data_readonly) {
            _ncError.NcError.get(context).sourceDataReadOnly(targetSource.alias);
        }
        const models = await targetSource.getModels(targetContext);
        const tableNameLengthLimit = _nocodbsdk.SqlUiFactory.create({
            client: targetSource.type
        }).tableNameLengthLimit;
        const uniqueTitle = await (0, _nocodbsdk.appendToLength)({
            value: (_body_title = body.title) != null ? _body_title : model.title,
            appendage: body.title ? '' : ' copy',
            isExists: async (needle)=>models.some((k)=>k.title === needle),
            maxLength: tableNameLengthLimit,
            suffix: _nocodbsdk.AppendToLengthSuffix._
        });
        return {
            uniqueTitle,
            sourceBase: base,
            sourceModel: model,
            sourceSource,
            targetSource
        };
    }
};
